
import React, { useEffect, useState } from "react";
import axios from "axios";
import Sidebar from "../StudentDashboard/Sidebar";
import Header from "../StudentDashboard/Headers";
import MyPrograms from "./MyProgram";
import { API_URL } from "../../config/api";

const adminRoles = ["super_admin", "org_admin", "training_partner_admin"];

const Parent = () => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserAndCourses = async () => {
      try {
        const token = localStorage.getItem("access_token");

        if (!token) {
          console.error("No access token found");
          setLoading(false);
          return;
        }

        const currentUser = await axios.get(`${API_URL}/current_user`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        const userId = currentUser.data?.user_id;
        const userRole = currentUser.data?.roles?.[0]?.name;

        if (!userId) {
          console.error("user_id missing");
          setLoading(false);
          return;
        }

        const userDetailRes = await axios.get(`${API_URL}/user/${userId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        const formattedUser =
          userDetailRes.data?.data || userDetailRes.data || null;

        if (adminRoles.includes(userRole)) {
          const [adminSummaryRes, programsRes] = await Promise.all([
            axios.get(`${API_URL}/user/admin/instructors`, {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }),
            axios.get(`${API_URL}/courses/programs`, {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }),
          ]);

          const summary = adminSummaryRes.data?.data?.summary || {};
          const programsData = programsRes.data;

          setUserData({
            ...formattedUser,
            dashboard: {
              summary,
              scheduled_programs:           programsData?.scheduled_programs     ?? 0,
              non_scheduled_programs:       programsData?.non_scheduled_programs ?? 0,
              ongoing_programs:             programsData?.ongoing_programs       ?? 0,
              completed_programs:           programsData?.completed_programs     ?? 0,
              scheduled_programs_list:      programsData?.scheduled_programs_list     || [],
              non_scheduled_programs_list:  programsData?.non_scheduled_programs_list || [],
            },
          });
        } else {
          setUserData(formattedUser);
        }
      } catch (error) {
        console.error("ERROR FETCHING USER →", error);
        if (error.response) {
          console.log("ERROR RESPONSE →", error.response.data);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchUserAndCourses();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#4AACC5] mx-auto"></div>
        </div>
      </div>
    );
  }

  if (!userData) {
    return (
      <div className="flex items-center justify-center min-h-screen text-gray-600">
        Unable to load user data. Please log in again.
      </div>
    );
  }

  return (
    <div className="flex flex-col h-screen bg-gray-50 overflow-hidden">
      <div className="flex-shrink-0">
        <Header userData={userData} />
      </div>
      <div className="flex flex-1 overflow-hidden">
        <div className="w-56 bg-white border-r border-neutral-200 flex-shrink-0">
          <Sidebar />
        </div>
        <div className="flex-1 p-4 overflow-y-auto">
          <MyPrograms userData={userData} />
        </div>
      </div>
    </div>
  );
};

export default Parent;